<script setup>
/** @typedef {import('.').Menu} Menu */
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/useAuthStore'
import { UserRole } from '@/const/roles'

/**@type {Readonly<{item: Menu}>} */
const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
})

const route = useRoute()
const authStore = useAuthStore()

/**
 * Map sidebar paths to the detail-page prefixes that should keep
 * the menu item highlighted.
 */
const childPrefixes = computed(() => {
  const prefixes = {
    '/rfqlist': ['/cs/', '/dashboard'],
    '/dashboard': ['/cs/'],
    '/qcflist': ['/quotation-summary/', '/preview-quotation-summary/', '/dashboard'],
  }

  // If role is admin, remove '/dashboard' from '/qcflist'
  if (authStore.userRole === UserRole.ADMIN) {
    prefixes['/qcflist'] = ['/quotation-summary/', '/preview-quotation-summary/']
  }

  return prefixes
})

const isActive = computed(() => {
  const prefixes = childPrefixes.value[props.item?.to]
  if (!prefixes) return undefined // let Vuetify handle it normally
  return prefixes.some(p => route.path.startsWith(p)) || undefined
})
</script>

<template>
  <v-list-item
    class="mb-1"
    color="primary"
    :disabled="item?.disabled"
    :href="item?.type === 'external' ? item?.to : ''"
    :title="item.title"
    :target="item?.type === 'external' ? '_blank' : ''"
    :to="item?.type === 'external' ? '' : item?.to"
    :prepend-icon="item.icon"
    :active="isActive"
    rounded
  />
</template>
